export default "__VITE_ASSET__BpWFUSMN__"